/**
 * Created by fworld on 2019/9/20.
 */
import request from '@/util/request'

export const deviceAllocateUnion = (params) => {
    return request({
        url: '/api/v1/delivery/device/allocate/union',
        method: 'get',
        params
    })
}


export const deviceAllocateList = (params) => {
    return request({
        url: '/api/v1/delivery/device/allocate/list',
        method: 'get',
        params
    })
}

export const deviceAllocateGroup= (data) => {
    return request({
        url: '/api/v1/delivery/device/allocateGroup',
        method: 'post',
        data
    })
}

export const deviceQueryProduct= (params) => {
    return request({
        url: '/api/v1/delivery/device/queryProduct',
        method: 'get',
        params
    })
}



